export default {
  title: 'Selecciona tu paquete',
  subtitle: 'Claro te presta paquetes para seguir comunicado',
  empty_packages: 'En este momento no hay paquetes disponibles.'
}
